/* eslint-disable
  jsx-a11y/label-has-associated-control,
  react/no-unescaped-entities,
  no-nested-ternary,
  no-confusing-arrow,
  jsx-a11y/no-autofocus,
  no-unused-vars
*/
import React from 'react';

/** Default employee record structure */
export const INIT = {
  empCode: '',
  location: '',
  holidayGrp: '',
  firstName: '',
  desgInternal: '',
  nationality: '',
  middleName: '',
  desgExternal: '',
  religion: '',
  lastName: '',
  desgVisa: '',
  dateOfBirth: '',
  shortName: '',
  apprGroup: '',
  gender: 'Male',
  entity: '',
  classification: '',
  maritalStatus: '',
  costCentre: '',
  classification2: '',
  reporting1: '',
  reporting1Name: '',
  sponsor: '',
  department: '',
  reporting2: '',
  reporting2Name: '',
  bloodGroup: '',
  section: '',
  deptMgr: '',
  deptMgrName: '',
  status: '',
  payMode: '',
  bankCode: '',
  bankBranch: '',
  ibanAcNo: '',
  acName: '',
  payCurrency: 'Dirhams',
  payGroup: '',
  wpsNo: '',
  financeCode: '',
  otEligibility: 'Yes',
  weeklyHoliday: {
    friday: { f: true, h: false },
    saturday: { f: true, h: false },
    sunday: { f: false, h: false },
    monday: { f: false, h: false },
    tuesday: { f: false, h: false },
    wednesday: { f: false, h: false },
    thursday: { f: false, h: false },
  },
  weeklyHolidayApi: {
    friday: { f: false, h: false },
    saturday: { f: false, h: false },
    sunday: { f: false, h: false },
    monday: { f: false, h: false },
    tuesday: { f: false, h: false },
    wednesday: { f: false, h: false },
    thursday: { f: false, h: false },
  },
  travelEligibility: 'Yes',
  ticketsContract: '',
  ticketsActual: '',
  travelSector: '',
  travelClass: '',
  hireDate: '',
  reHireDate: '',
  validity: '',
  accrualType: 'Standard Accrual',
  noticeDays: '',
  annualLeaveDays: '',
  carryOver: '',
  indemnity: true,
  leaveSalary: true,
  bonus: true,
  leaveFare: true,
  bonusScheme: '',
  pcmScheme: '',
  passportNo: '',
  issuePlace: '',
  issueDate: '',
  expiryDate: '',
  localMobile: '',
  outstationMobile: '',
  email: '',
  arabicName: '',
  photo: '',
  signature: '',
  /** DB path for photo when UI `photo` is base64 (keeps multipart fields small). */
  photoPath: '',
  /** Server file path for signature — same as photoPath for signature. */
  signaturePath: '',
  postStatus: '0',
};

/** Mandatory field names — validated before save */
export const MF = new Set([
  'empCode',
  'firstName',
  'lastName',
  'shortName',
  'status',
  'dateOfBirth',
  'maritalStatus',
  'religion',
  'entity',
  'department',
  'section',
  'location',
  'desgInternal',
  'desgExternal',
  'apprGroup',
  'classification',
  'classification2',
  'costCentre',
  'holidayGrp',
  'reporting1',
  'deptMgr',
  'nationality',
  'gender',
  'hireDate',
  'payCurrency',
  'payMode',
  'financeCode',
  'otEligibility',
  'travelEligibility',
  'accrualType',
  'noticeDays',
  'annualLeaveDays',
  'carryOver',
  'bonusScheme',
  'pcmScheme',
  'email',
  'sponsor',
]);

/** Default dropdown options fallback */
export const DEFAULT_OPTIONS = {
  location: [
    'Dubai',
    'Abu Dhabi',
    'Sharjah',
    'Ajman',
    'RAK',
    'Fujairah',
    'UAQ',
  ],
  holidayGrp: ['Group A', 'Group B', 'Group C'],
  desgInternal: [
    'Manager',
    'Senior Engineer',
    'Engineer',
    'Analyst',
    'Technician',
    'Supervisor',
    'Director',
    'VP',
  ],
  nationality: [
    'UAE',
    'India',
    'Pakistan',
    'Philippines',
    'Bangladesh',
    'Egypt',
    'Jordan',
    'UK',
    'USA',
  ],
  religion: ['Muslim', 'Christian', 'Hindu', 'Sikh', 'Other'],
  apprGroup: ['DAME'],
  entity: ['Entity A', 'Entity B', 'Entity C'],
  classification: ['1A', '1B', '2A', '2B', '3A', '3B', 'MM'],
  classification2: ['General', 'Technician'],
  maritalStatus: ['Single', 'Married', 'Divorced', 'Widowed'],
  costCentre: ['590000', '590001', '590002', '590200', '595000'],
  sponsor: ['FZE', 'LLC Dubai', 'Other'],
  department: ['IT', 'HR', 'Finance', 'Administration', 'Marketing', 'Sales'],
  bloodGroup: ['A+', 'A-', 'B+', 'B-', 'AB', 'AB+', 'O+', 'O-'],
  section: ['Section A', 'Section B', 'Section C', 'Section D'],
  status: [
    { value: 'HSTATPM', label: 'Permanent' },
    { value: 'HSTATTM', label: 'Temporary' },
    { value: 'HSTATTI', label: 'Temporary - Intern' },
  ],
  payMode: ['Bank', 'Cash', 'Cheque'],
  bankCode: [
    'Abu Dhabi Commercial Bank',
    'Abu Dhabi Islamic Bank',
    'Emirates NBD',
    'Mashreq Bank',
    'First Abu Dhabi Bank',
  ],
  bankBranch: ['Main Branch', 'Mall Branch', 'Industrial Branch'],
  payCurrency: ['Dirhams', 'US Dollar', 'Euro', 'Great Britain Pounds'],
  payGroup: ['DAAD - WPS DAAD', 'FZE - WPS FZE', 'LLC - WPS LLC DUBAI'],
  travelClass: ['Economy', 'Business', 'First'],
  accrualType: ['Standard Accrual', 'Custom Accrual', 'No Accrual'],
  issuePlace: [
    'Dubai',
    'Abu Dhabi',
    'Delhi',
    'Manila',
    'Dhaka',
    'Cairo',
    'London',
  ],
  ticketsContract: [
    'Self - Yearly',
    'Self+Spouse',
    'Self+1 Children',
    'Self+2 Children',
  ],
  ticketsActual: [
    'Self - Yearly',
    'Self+Spouse',
    'Self+1 Children',
    'Self+2 Children',
  ],
  travelSector: [
    'Abu Dhabi - Cairo',
    'Abu Dhabi - Chennai',
    'Abu Dhabi - Cochin',
    'Dubai-Delhi',
    'Dubai-Manila',
    'Dubai-Dhaka',
    'Dubai-Cairo',
    'Dubai-London',
    'Dubai-Karachi',
    'Dubai-Amman',
    'Custom',
  ],
  annualLeaveDays: ['15', '21', '22', '24', '25', '30'],
  bonusScheme: [
    'Direct Sales Scheme 1',
    'Indirect sales Scheme 1',
    'Sales Support Scheme 1',
    'Corp Function scheme 1',
    'Not Applicable',
  ],
  pcmScheme: ['Employee', 'Manager', 'None'],
};

/** Sample employee data for demo */
export const SAMPLE = [];

export const WEEKDAYS = [
  'friday',
  'saturday',
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
];

export const COUNTRIES = [
  'UAE',
  'India',
  'Pakistan',
  'Philippines',
  'Bangladesh',
  'Egypt',
  'Jordan',
  'UK',
  'USA',
  'Saudi Arabia',
  'Oman',
  'Qatar',
  'Bahrain',
  'Kuwait',
];

export const DEP_INIT = {
  relationship: '',
  relName: '',
  nationalId: '',
  passportNo: '',
  issueDate: '',
  expiryDate: '',
  issuePlace: '',
  visaNo: '',
  fileNo: '',
  visaIssueDate: '',
  visaExpiryDate: '',
  dob: '',
  nationality: '',
  ticketsPerYear: '',
  ticketEligibleFrom: '',
};

export const DOC_TYPES = [
  'Passport',
  'Visa',
  'National ID',
  'Driving License',
  'Labour Card',
  'Emirates ID',
  'Trade License',
  'Other',
];

export const FACILITY_TYPES = [
  'School Fees',
  'SIM (Voice)',
  'SIM (Data)',
  'Medical Insurance',
  'Housing',
  'Transport',
  'Gym Membership',
  'Other',
];
export const FACILITY_CATS = [
  'Grade 1',
  'Grade 2',
  'Grade 3',
  'Grade 4',
  'Grade 5',
  'Grade 6',
  'Grade 7',
  'Grade 8',
  'Grade 9',
  'Grade 10',
  'Grade 11',
  'Grade 12',
  'DU SIM',
  'Etisalat SIM',
  'Basic',
  'Standard',
  'Premium',
];

export const COMP_ROWS = [
  { paymentType: 'Payments', currency: 'Dirhams', payCode: 'BASIC' },
  { paymentType: 'Payments', currency: 'Dirhams', payCode: 'BASIC (TRAINEE)' },
  {
    paymentType: 'Payments',
    currency: 'Dirhams',
    payCode: 'HOUSING ALLOWANCE',
  },
  {
    paymentType: 'Payments',
    currency: 'Dirhams',
    payCode: 'TRANSPORT ALLOWANCE',
  },
  { paymentType: 'Payments', currency: 'Dirhams', payCode: 'FOOD ALLOWANCE' },
  {
    paymentType: 'Payments',
    currency: 'Dirhams',
    payCode: 'PHONE ALLOWANCE (FIXED)',
  },
  {
    paymentType: 'Payments',
    currency: 'Dirhams',
    payCode: 'HARDSHIP ALLOWANCE',
  },
  {
    paymentType: 'Payments',
    currency: 'Dirhams',
    payCode: 'SKILL DEVELOPMENT',
  },
  {
    paymentType: 'Payments',
    currency: 'Dirhams',
    payCode: 'RESPONSIBILITY FEE',
  },
  { paymentType: 'Payments', currency: 'Dirhams', payCode: 'CAR ALLOWANCE' },
  {
    paymentType: 'Payments',
    currency: 'Dirhams',
    payCode: 'EDUCATION ALLOWANCE',
  },
  {
    paymentType: 'Payments',
    currency: 'Dirhams',
    payCode: 'SPECIAL ALLOWANCE',
  },
  {
    paymentType: 'Payments',
    currency: 'Dirhams',
    payCode: 'SENIORITY ALLOWANCE',
  },
  { paymentType: 'Payments', currency: 'Dirhams', payCode: 'DETACHMENT FEE' },
  { paymentType: 'Payments', currency: 'Dirhams', payCode: 'MEAL VOUCHERS' },
  { paymentType: 'Payments', currency: 'Dirhams', payCode: 'COST OF LIVING' },
  { paymentType: 'Deductions', currency: 'Dirhams', payCode: 'GOSI' },
];

export const ALLOC_TYPES = ['Cost Centre', 'Product'];

export const ATTACH_CATS = [
  'Passport Copy',
  'Visa Copy',
  'Emirates ID',
  'Labour Card',
  'Educational Certificate',
  'Experience Letter',
  'Medical Report',
  'Contract',
  'Photo',
  'Other',
];

/** Sub-screen configuration for More Actions dropdown */
export const SUB_SCREENS = [
  {
    key: 'compensation',
    label: 'Compensation',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path
          d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    key: 'costAllocation',
    label: 'Cost Allocation',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path
          d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.66 0 3-4.03 3-9s-1.34-9-3-9m0 18c-1.66 0-3-4.03-3-9s1.34-9 3-9m-9 9a9 9 0 019-9"
          stroke="currentColor"
          strokeWidth="2"
        />
      </svg>
    ),
  },
  {
    key: 'documents',
    label: 'Documents',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path
          d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 2v6h6M16 13H8m8 4H8m2-8H8"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    key: 'dependents',
    label: 'Dependents',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path
          d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" />
        <path
          d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
  {
    key: 'address',
    label: 'Address',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path
          d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2" />
      </svg>
    ),
  },
  {
    key: 'facilities',
    label: 'Facilities',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path
          d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 22V12h6v10"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    key: 'attachments',
    label: 'Attachments',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path
          d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];
